var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27787 8.045C6.07187 8.154 5.79787 8.433 5.68987 8.644C5.57587 8.867 5.57587 9.132 5.69087 9.363C5.81587 9.613 12.0389 15.836 12.2889 15.961C12.5199 16.076 12.7839 16.076 13.0149 15.961C13.2649 15.836 19.4879 9.613 19.6129 9.363C19.7889 9.01 19.6989 8.645 19.3529 8.299C19.0129 7.959 18.6319 7.868 18.2799 8.044C18.1679 8.1 17.2099 9.029 15.3819 10.853L12.6519 13.579L9.92187 10.853C8.09387 9.029 7.13587 8.1 7.02387 8.044C6.80387 7.934 6.48687 7.935 6.27787 8.045Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownSquare);
export default __webpack_public_path__ + "static/media/dropdown_square.svg";
export { ForwardRef as ReactComponent };